import React from 'react';
import LogoMenuBar from '../LogoMenuBar';
import FooterMenuBar from '../FooterMenuBar';
import ButtonLogout from '../ButtonLogout';
import { MenuContainer, WrapperFooter } from './style';
import ButtonMenuBar from '../ButtonMenuBar';

function MenuBarPages({ children }) {
  return (
    <MenuContainer>
      <WrapperFooter>
        <LogoMenuBar />
        <ButtonMenuBar name="Home" icon="/images/icons/home.svg" link="/" />
        {children}
      </WrapperFooter>
      <WrapperFooter>
        <ButtonLogout />
        <FooterMenuBar />
      </WrapperFooter>
    </MenuContainer>
  );
}

export default MenuBarPages;
